
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chip } from "primereact/chip";
import { useRef, useState } from "react";
import { Card } from "primereact/card";
import { DataScroller } from 'primereact/datascroller';
import { Button } from "primereact/button";



export default function AcoesCompleta({
  acoes
}: {
  acoes: any
}) {
  const { t } = useTranslation();
  const ds = useRef<DataScroller>(null);
  const [loader, setLoader] = useState<number>(10);
  const footer = <Button disabled={acoes.length <= 10 || loader >= acoes.length} className="buttom-custom" icon="pi pi-plus" label="Mais Ações" onClick={() => { setLoader(loader + 10); ds.current!.load(); }} />;

  const formatDateToBR = (dateString: string) => {
    if (!dateString) return 'Não Informado';

    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR');
    } catch (error) {
      return dateString;
    }
  };

  const itemTemplate = (acao: any) => {
    return (
      <>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('processo')}</label>
              <Chip style={{ width: "100%" }} label={acao.numero} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('comarca')}</label>
              <Chip style={{ width: "100%" }} label={acao.comarca} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('vara')}</label>
              <Chip style={{ width: "100%" }} label={acao.vara} />
            </div>
          </div>
          <div className="col">
            <div >
              <label className="label-dados">{t('cidadeUF')}</label>
              <Chip style={{ width: "100%" }} label={acao.cidadeUF} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('tipo')}</label>
              <Chip style={{ width: "100%" }} label={acao.tipo} />
            </div>
          </div>
          <div className="col">
            <div >
              <label className="label-dados">{t('Classe Processual')}</label>
              <Chip style={{ width: "100%" }} label={acao.classeProcessual ? acao.classeProcessual : 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('valor')}</label>
              <Chip style={{ width: "100%" }} label={acao.valor ? acao.valor : 'Não Informado'} />
            </div>
          </div>
          <div className="col">
            <div >
              <label className="label-dados">{t('origem')}</label>
              <Chip style={{ width: "100%" }} label={acao.origem} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('assunto')}</label>
              <Chip style={{ width: "100%" }} label={acao.assunto ? acao.assunto : 'Não Informado'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('status')}</label>
              <Chip style={{ width: "100%" }} label={acao.status ? acao.status : 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('justicaGratuita')}</label>
              <Chip style={{ width: "100%" }} label={acao.eJuizaGratuita && acao.eJuizaGratuita ? 'Sim' : 'Não'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('prioritario')}</label>
              <Chip style={{ width: "100%" }} label={acao.ePrioritario && acao.ePrioritario ? 'Sim' : 'Não'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('processoDigital')}</label>
              <Chip style={{ width: "100%" }} label={acao.eProcessoDigital && acao.eProcessoDigital ? 'Sim' : 'Não'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('segredoJustica')}</label>
              <Chip style={{ width: "100%" }} label={acao.eSegredoJustica && acao.eSegredoJustica ? 'Sim' : 'Não'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('tutelaAntecipada')}</label>
              <Chip style={{ width: "100%" }} label={acao.eTutelaAntecipada && acao.eTutelaAntecipada ? 'Sim' : 'Não'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('juiz')}</label>
              <Chip style={{ width: "100%" }} label={acao.juiz ?? 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('dataDistribuicao')}</label>
              <Chip style={{ width: "100%" }} label={acao.dataDistribuicao} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('dataAutuacao')}</label>
              <Chip style={{ width: "100%" }} label={acao.dataAutuacao ? formatDateToBR(acao.dataAutuacao) : 'Não Informado'} />
            </div>
          </div>
        </div>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('grauProcesso')}</label>
              <Chip style={{ width: "100%" }} label={acao.grauProcesso ?? 'Não Informado'} />
            </div>
          </div>
          <div className="col p-fluid flex flex-wrap">
            <div >
              <label className="label-dados">{t('dataArquivamento')}</label>
              <Chip style={{ width: "100%" }} label={acao.dataArquivamento ? formatDateToBR(acao.dataArquivamento) : 'Não Informado'} />
            </div>
          </div>

        </div>
        <br></br>
        <DataTable header={t('partes')} size="small" value={acao.partes} tableStyle={{ minWidth: '50rem' }}>
          <Column field="tipo" header={t('tipo')}></Column>
          <Column field="data" header={t('data')}></Column>
          <Column field="polo" header={t('polo')}></Column>
          <Column field="advogado" header={t('advogados')}></Column>
          <Column field="documento" header={t('documento')}></Column>
          <Column field="nome" header={t('nome')}></Column>
        </DataTable>
        <br></br>
        <br></br>
        {acao.movimentos ? (
          <>
            <br></br>
            <Panel header={t('movimentacoes')} collapsed toggleable>
              <DataTable header={t('movimentacoes')} size="small" value={acao.movimentos} tableStyle={{ minWidth: '50rem' }}>
                <Column field="data" header={t('data')}></Column>
                <Column field="descricao" header={t('descricao')}></Column>
              </DataTable>
            </Panel>
          </>
        ) : ''}
        <br></br>
        <div className="line"></div>
        <br></br>
      </>
    )
  }

  return (
    <Panel header={t('acoesCompleta')}>
      <div className="flex-consulta  flex-wrap gap-3">
        {acoes[0].resumos.map((item: any, index: number) => (

          <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
            <div className="flex-consulta  justify-content-between gap-5">
              <div className="flex-consulta  flex-column gap-1">
                <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
              </div>
              <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                <i className={item.icon} />
              </span>
            </div>
          </Card>

        ))}
      </div>

      <br></br>
      <DataScroller ref={ds} value={acoes} itemTemplate={itemTemplate} rows={10} loader footer={footer} />

    </Panel>
  )
}
